import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useState } from "react";
export default function useLayout() {
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    toolbarHeight = _useState2[0],
    setToolbarHeight = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    headerHeight = _useState4[0],
    setHeaderHeight = _useState4[1];
  return {
    toolbarHeight: toolbarHeight,
    headerHeight: headerHeight,
    setToolbarHeight: setToolbarHeight,
    setHeaderHeight: setHeaderHeight
  };
}